module.exports = __webpack_public_path__ + "static/media/ask_scientist_button.cd51a44c.svg";